import { useEffect, useState } from 'react';

/*
 * DOM-ready lifecycles
 */
export const useOnMount = (onMount?: () => void): boolean => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    onMount && onMount();
    setIsMounted(true);
    return () => setIsMounted(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isMounted;
};
